module.exports = __webpack_public_path__ + "static/media/socialpiper-create-esp.26e12882.jpg";